// ----------------------------------------------------------------------------
// Snippet: Country Switcher
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_country-language-switcher.scss';


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const HEADER_SELECTOR            = '.header';
const HEADER_CONTAINER_SELECTOR  = '.header__container';
const COUNTRY_SWITCHER           = '.country-switcher';
const COUNTRY_SWITCHER_TOGGLE    = '.country-switcher__toggle';
const COUNTRY_SWITCHER_LIST      = '.country-switcher__list';
const COUNTRY_SWITCHER_ITEM      = '.country-switcher__item';
const COUNTRY_SWITCHER_LINK      = '.country-switcher__link';
const LANG_SWITCHER              = '.language-switcher';
const LANG_SWITCHER_TOGGLE       = '.language-switcher__toggle';
const LANG_SWITCHER_LIST         = '.language-switcher__list';
const LANG_SWITCHER_ITEM         = '.language-switcher__item';
const LANG_SWITCHER_LINK         = '.language-switcher__link';
const INPUT_SELECTOR             = 'input[name="country_code"], input[name="language_code"]';
const SEARCH_FORM                = '.search-box';

// Classes
const COUNTRY_SWITCHER_CLASS  = 'country-switcher';
const LANG_SWITCHER_CLASS     = 'language-switcher';
const OPEN_CLASS              = 'is-open';
const HEADER_BUMP_LOCK_CLASS  = 'js--bump-lock';

const $header                = document.querySelector(HEADER_SELECTOR);
const $headerContainer       = document.querySelector(HEADER_CONTAINER_SELECTOR);

// -------------------------------------
// Helpers
// -------------------------------------

function initCountryLanguageSwitcher() {
    const body                   = document.querySelector('body');
    const countrySwitcher        = document.querySelector(COUNTRY_SWITCHER);
    const countrySwitcherToggle  = document.querySelector(COUNTRY_SWITCHER_TOGGLE);
    const countrySwitcherList    = document.querySelector(COUNTRY_SWITCHER_LIST);
    const countrySwitcherItems   = document.querySelectorAll(COUNTRY_SWITCHER_ITEM);
    const countrySwitcherLinks   = document.querySelectorAll(COUNTRY_SWITCHER_LINK);
    const languageSwitcher       = document.querySelector(LANG_SWITCHER);
    const languageSwitcherToggle = document.querySelector(LANG_SWITCHER_TOGGLE);
    const languageSwitcherList   = document.querySelector(LANG_SWITCHER_LIST);
    const languageSwitcherItems  = document.querySelectorAll(LANG_SWITCHER_ITEM);
    const languageSwitcherLinks  = document.querySelectorAll(LANG_SWITCHER_LINK);

    countrySwitcher.info = {
        $toggle: countrySwitcherToggle,
        $list  : countrySwitcherList,
        $switcher : countrySwitcher,
    };

    countrySwitcherToggle.info = {
        $switcher : countrySwitcher,
        $list : countrySwitcherList
    };

    if( languageSwitcherToggle != null ) {
        languageSwitcher.info = {
            $toggle: languageSwitcherToggle,
            $list  : languageSwitcherList,
            $switcher : languageSwitcher,
        };

        languageSwitcherToggle.info = {
            $switcher : languageSwitcher,
            $list : languageSwitcherList
        };
    }

    // Close the switcher if clicking outside
    body.addEventListener('click', function(event) {
        if (event.target.closest(COUNTRY_SWITCHER_TOGGLE) === null && countrySwitcherToggle != null ) {
            closeCountryLangDropdown(countrySwitcherToggle, countrySwitcherList, countrySwitcher);
        }

        if( languageSwitcherToggle != null ) {
            if (event.target.closest(LANG_SWITCHER_TOGGLE) === null ) {
                closeCountryLangDropdown(languageSwitcherToggle, languageSwitcherList, languageSwitcher);
            }

            if (event.target.closest(SEARCH_FORM) == null && document.querySelector(SEARCH_FORM) != null &&
                event.target.closest(COUNTRY_SWITCHER_TOGGLE) == null && countrySwitcherToggle != null &&
                event.target.closest(LANG_SWITCHER_TOGGLE) == null && languageSwitcherToggle != null ) {
                removeBumpHeaderLock($header);
            }
        } else {
            if (event.target.closest(SEARCH_FORM) == null && document.querySelector(SEARCH_FORM) != null &&
                event.target.closest(COUNTRY_SWITCHER_TOGGLE) == null && countrySwitcherToggle != null ) {
                removeBumpHeaderLock($header);
            }
        }
    });

    // Close the switcher when pressing 'Escape'
    countrySwitcher.addEventListener('keydown', handleKeyboard);
    // countrySwitcher.addEventListener('keyup', handleKeyup);
    if( languageSwitcherToggle != null ) {
        languageSwitcher.addEventListener('keydown', handleKeyboard);
    }

    // Open/close the switcher when clicking on the toggle
    countrySwitcherToggle.addEventListener('click', (event) => {
        event.preventDefault();
        handleToggleClick(countrySwitcherToggle);
    });
    if( languageSwitcherToggle != null ) {
        languageSwitcherToggle.addEventListener('click', (event) => {
            event.preventDefault();
            handleToggleClick(languageSwitcherToggle, 78);
        });
    }

    // Close the switcher when tabbing out
    // Country switcher
    countrySwitcherItems.forEach(function(item) {
        item.info = {
            $toggle: countrySwitcherToggle,
            $list  : countrySwitcherList
        };

        item.addEventListener('keydown', handleKeyboard);
    });

    countrySwitcherLinks.forEach((link) => {
        link.container = countrySwitcher;
        link.addEventListener('click', handleItemClick);
    });

    // Language switcher
    if( languageSwitcherToggle != null ) {
        languageSwitcherItems.forEach(function(item) {
            item.info = {
                $toggle: languageSwitcherToggle,
                $list  : languageSwitcherList
            };

            item.addEventListener('keydown', handleKeyboard);
        });

        languageSwitcherLinks.forEach((link) => {
            link.container = languageSwitcher;
            link.addEventListener('click', handleItemClick);
        });
    }
}

const handleToggleClick = (element, customValue) => {
    const $this = element;
    const switcherList = $this.info.$list;
    const switcher = $this.info.$switcher;

    if ($this.classList.contains(OPEN_CLASS)) {
        closeCountryLangDropdown($this, switcherList, switcher);
        removeBumpHeaderLock($header);
    } else {
        $this.classList.add(OPEN_CLASS);
        $this.classList.add(HEADER_BUMP_LOCK_CLASS);
        addBumpHeaderLock($header);
        $this.setAttribute('aria-expanded', 'true');
        switcher.classList.add(OPEN_CLASS);
        switcherList.classList.add(OPEN_CLASS);
        switcherRightPosition($headerContainer, switcherList, customValue);
    }
}

const handleItemClick = (event) => {
    event.preventDefault();

    const $this = event.currentTarget;
    const form = $this.closest('form');
    const input = $this.container.querySelector(INPUT_SELECTOR);

    if (input.value !== $this.dataset.value) {
        input.value = $this.dataset.value;
        if (form) form.submit();
    }
}

function handleKeyboard(event) {
    const $this  = event.currentTarget;

    if ($this.classList.contains(COUNTRY_SWITCHER_CLASS) || $this.classList.contains(LANG_SWITCHER_CLASS)) {
        const toggle = $this.info.$toggle;
        const switcherList   = $this.info.$list;
        const switcher   = $this.info.$switcher;

        if (event.key === 'Escape' && toggle.classList.contains(OPEN_CLASS)) {
            closeCountryLangDropdown(toggle, switcherList, switcher);
        }
    } else {
        if (event.key === "Tab") {
            const nextItem  = $this.nextElementSibling;
            const prevItem  = $this.previousElementSibling;
            const parent    = $this.parentNode;
            const firstItem = prevItem === null || (prevItem.classList.contains('is-current') && parent.firstElementChild == prevItem);
            const lastItem  = nextItem === null || (nextItem.classList.contains('is-current') && parent.lastElementChild == nextItem);

            if ((event.shiftKey && firstItem) || lastItem) {
                closeCountryLangDropdown($this.info.$toggle, $this.info.$list, $this.info.$switcher);
            }
        }
    }
}

function closeCountryLangDropdown(toggle, list, switcher) {
    toggle.classList.remove(HEADER_BUMP_LOCK_CLASS);
    toggle.classList.remove(OPEN_CLASS);
    list.classList.remove(OPEN_CLASS);
    switcher.classList.remove(OPEN_CLASS);
    toggle.setAttribute("aria-expanded", "false");
}

function removeBumpHeaderLock($header) {
    if ($header != null ) {
        $header.classList.remove(HEADER_BUMP_LOCK_CLASS);
    }
}

function addBumpHeaderLock($header) {
    if ($header != null ) {
        $header.classList.add(HEADER_BUMP_LOCK_CLASS);
    }
}

function switcherRightPosition($headerContainer, switcherList, customValue = 0) {
    if ($headerContainer != null && switcherList != null) {
        const $headerContainerRight  = $headerContainer.getBoundingClientRect().right + window.scrollX + customValue;

        switcherList.style.right = 'calc(100% - ' + $headerContainerRight + 'px)';
    }
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    initCountryLanguageSwitcher();
});

window.addEventListener('resize', function() {
    const $headerContainer      = document.querySelector(HEADER_CONTAINER_SELECTOR);
    const countrySwitcherList   = document.querySelector(COUNTRY_SWITCHER_LIST);
    const languageSwitcherList   = document.querySelector(LANG_SWITCHER_LIST);

    switcherRightPosition($headerContainer, countrySwitcherList);
    if( languageSwitcherList != null ) {
        switcherRightPosition($headerContainer, languageSwitcherList, 78);
    }
});
